import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { usersQueryKeys } from '../data';
import { logger } from '@/utils';
import { createUser } from '../api';

export const useCreateUserMutation = (
  options: Partial<UseMutationOptions<any, any, any, any>> = {}
) => {
  const mutation = useMutation({
    mutationKey: usersQueryKeys.createUser,
    mutationFn: createUser,
    onMutate: (data) => {
      return { ...data };
    },
    onSuccess: (data, variables, context) => {
      logger.log(data);
      if (options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error) => {
      logger.log(error);
    },
    ...options,
  });
  return mutation;
}
